import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";

// ---- image imports ----
import img01 from "../../images/project/1.jpg";
import img02 from "../../images/project/2.jpg";
import img03 from "../../images/project/3.jpg";
import img04 from "../../images/project/4.jpg";
import img05 from "../../images/project/img02.jpg";
import img06 from "../../images/project/img03.jpg";

import icon4 from "../../images/icon/project-icon04.svg";
import icon5 from "../../images/icon/project-icon05.svg";
import icon6 from "../../images/icon/project-icon06.svg";
import icon7 from "../../images/icon/project-icon07.svg";

const projectImages: Record<string, string> = {
  "enterprise-rag-sap-integration": img01,
  "omnichannel-whatsapp-ai-agent": img02,
  "intelligent-invoice-logistics": img03,
  "iot-predictive-maintenance": img04,
  "computer-vision-pcb-inspection": img05,
  "dynamic-pricing-retail": img06,
  "1": img01,
  "2": img02,
  "3": img03,
  "4": img04,
  "5": img05,
  "6": img06,
};

// ---- check icon svg ----
const CheckIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      opacity="0.2"
      d="M24 12C24 13.024 22.742 13.868 22.49 14.812C22.23 15.788 22.888 17.148 22.394 18.002C21.892 18.87 20.382 18.974 19.678 19.678C18.974 20.382 18.87 21.892 18.002 22.394C17.148 22.888 15.788 22.23 14.812 22.49C13.868 22.742 13.024 24 12 24C10.976 24 10.132 22.742 9.188 22.49C8.212 22.23 6.852 22.888 5.998 22.394C5.13 21.892 5.026 20.382 4.322 19.678C3.618 18.974 2.108 18.87 1.606 18.002C1.112 17.148 1.77 15.788 1.51 14.812C1.258 13.868 0 13.024 0 12C0 10.976 1.258 10.132 1.51 9.188C1.77 8.212 1.112 6.852 1.606 5.998C2.108 5.13 3.618 5.026 4.322 4.322C5.026 3.618 5.13 2.108 5.998 1.606C6.852 1.112 8.212 1.77 9.188 1.51C10.132 1.258 10.976 0 12 0C13.024 0 13.868 1.258 14.812 1.51C15.788 1.77 17.148 1.112 18.002 1.606C18.87 2.108 18.974 3.618 19.678 4.322C20.382 5.026 21.892 5.13 22.394 5.998C22.888 6.852 22.23 8.212 22.49 9.188C22.742 10.132 24 10.976 24 12Z"
      fill="#00FF97"
    />
    <path
      d="M15.5559 9.14076L11.3992 13.178L9.24437 11.0869C8.77664 10.6326 8.01773 10.6326 7.55001 11.0869C7.08229 11.5412 7.08229 12.2783 7.55001 12.7326L10.5729 15.6686C11.0279 16.1105 11.7668 16.1105 12.2218 15.6686L17.2484 10.7864C17.7162 10.3321 17.7162 9.59504 17.2484 9.14076C16.7807 8.68648 16.0236 8.68648 15.5559 9.14076Z"
      fill="#00FF97"
    />
  </svg>
);

interface ProjectItemType {
  id: string;
  slug: string;
  title: string;
  client: string;
  industry: string;
  location: string;
  service?: string;
  summary: string;
  challenge?: string;
  solution?: string;
  description: string;
  deliverables?: string[];
  impact: string[];
  techs: string[];
}

interface ProjectDetailsSectionProps {
  currentProject?: ProjectItemType;
}

const ProjectDetailsSection: React.FC<ProjectDetailsSectionProps> = ({
  currentProject,
}) => {
  const { t } = useLanguage();
  const project = currentProject || t.projects.items[0];

  const docImage =
    projectImages[project.slug] || projectImages[project.id] || img01;

  const projectMeta = [
    {
      icon: icon4,
      label: t.projectDetails.serviceLabel,
      value: project.service || "Enterprise AI & LLM Integration",
    },
    // {
    //   icon: icon5,
    //   label: t.projectDetails.clientLabel,
    //   value: project.client,
    // },
    // {
    //   icon: icon6,
    //   label: t.projectDetails.locationLabel,
    //   value: project.location,
    // },
    // {
    //   icon: icon7,
    //   label: t.projectDetails.industryLabel,
    //   value: project.industry,
    // },
  ];

  const deliverablesList =
    project.deliverables || t.projectDetails.solutionDeliverables;

  return (
    <section className="project-details pb-100">
      <div className="container">
        {/* ========= ALL PROJECTS NAVIGATION PILLS ========= */}
        <div className="mb-50">
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              justifyContent: "center",
              padding: "16px 20px",
              borderRadius: "16px",
              background: "rgba(255, 255, 255, 0.03)",
              backdropFilter: "blur(12px)",
              border: "1px solid rgba(255, 255, 255, 0.08)",
            }}
          >
            {t.projects.items.map((proj) => {
              const isActive = proj.slug === project.slug;
              return (
                <Link
                  key={proj.id}
                  to={`/project-details/${proj.slug}`}
                  style={{
                    padding: "8px 18px",
                    borderRadius: "30px",
                    fontSize: "13px",
                    fontWeight: 600,
                    textDecoration: "none",
                    transition: "all 0.3s ease",
                    backgroundColor: isActive ? "#00FF97" : "rgba(255, 255, 255, 0.06)",
                    color: isActive ? "#00020F" : "rgba(255, 255, 255, 0.8)",
                    border: isActive
                      ? "1px solid #00FF97"
                      : "1px solid rgba(255, 255, 255, 0.12)",
                    boxShadow: isActive ? "0 0 14px rgba(0, 255, 151, 0.35)" : "none",
                  }}
                >
                  {proj.title}
                </Link>
              );
            })}
          </div>
        </div>

        {/* ========= HIGH-RES PROJECT DOCUMENTATION SHOWCASE ========= */}
        <div
          className="pca-mockup-frame mb-60"
          style={{
            maxWidth: "100%",
            borderRadius: "20px",
            boxShadow: "0 25px 60px rgba(0,0,0,0.6)",
          }}
        >
          {/* Cyber Browser Header */}
          <div className="pca-mockup-header" style={{ padding: "14px 22px" }}>
            <div className="pca-mockup-dots">
              <span className="pca-dot dot-red"></span>
              <span className="pca-dot dot-yellow"></span>
              <span className="pca-dot dot-green"></span>
            </div>
            <div className="pca-mockup-address" style={{ maxWidth: "420px" }}>
              <i className="fas fa-lock me-2" style={{ color: "#00FF97" }}></i>
              <span>enterprise.primaciptaartifisial.co.id/case-study/{project.slug}</span>
            </div>
            <div className="pca-mockup-live-badge">
              <span className="live-indicator"></span>
              PRODUCTION SYSTEM
            </div>
          </div>

          {/* Project Screenshot Container */}
          <div
            style={{
              position: "relative",
              width: "100%",
              maxHeight: "560px",
              overflow: "hidden",
              background: "#030712",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={docImage}
              alt={project.title}
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "560px",
                objectFit: "contain",
                display: "block",
              }}
            />
          </div>
        </div>

        {/* ========= PROJECT TITLE & EXECUTIVE SUMMARY ========= */}
        <div className="mb-40">
          <div className="d-flex align-items-center gap-2 mb-3">
            <span
              style={{
                color: "#00FF97",
                fontWeight: 700,
                fontSize: "13px",
                textTransform: "uppercase",
                letterSpacing: "1px",
                background: "rgba(0, 255, 151, 0.12)",
                padding: "4px 12px",
                borderRadius: "16px",
                border: "1px solid rgba(0, 255, 151, 0.3)",
              }}
            >
              {project.industry}
            </span>
            {/* <span style={{ color: "rgba(255,255,255,0.6)", fontSize: "14px" }}>
              {project.client} • {project.location}
            </span> */}
          </div>

          <h1
            className="details-content-title mb-25"
            style={{ fontSize: "clamp(28px, 4vw, 42px)", lineHeight: "1.25" }}
          >
            {project.title}
          </h1>

          <p
            style={{
              fontSize: "1.15rem",
              lineHeight: "1.8",
              color: "rgba(255,255,255,0.92)",
              fontWeight: 400,
            }}
          >
            {project.summary}
          </p>
        </div>

        {/* ========= METADATA INFO BAR ========= */}
        <ul className="project-meta ul_li_between mt-40 mb-60">
          {projectMeta.map((item, i) => (
            <li key={i}>
              <img src={item.icon} alt="icon" /> <span>{item.label}</span>{" "}
              {item.value}
            </li>
          ))}
        </ul>

        {/* ========= BUSINESS CHALLENGE & ARCHITECTURAL SOLUTION ========= */}
        <div className="row g-4 g-lg-5 mb-70">
          {/* Challenge Box */}
          <div className="col-lg-6">
            <div
              style={{
                height: "100%",
                padding: "35px 30px",
                borderRadius: "18px",
                background: "rgba(255, 255, 255, 0.025)",
                border: "1px solid rgba(255, 255, 255, 0.08)",
              }}
            >
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#FF5F56",
                  fontSize: "14px",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: "0.8px",
                  marginBottom: "16px",
                }}
              >
                <i className="fas fa-exclamation-triangle"></i>
                {t.projectDetails.challengeTitle}
              </div>
              <p
                style={{
                  fontSize: "1.02rem",
                  lineHeight: "1.8",
                  color: "rgba(255,255,255,0.85)",
                  margin: 0,
                }}
              >
                {project.challenge || project.description}
              </p>
            </div>
          </div>

          {/* Solution Box */}
          <div className="col-lg-6">
            <div
              style={{
                height: "100%",
                padding: "35px 30px",
                borderRadius: "18px",
                background: "linear-gradient(135deg, rgba(0, 255, 151, 0.06) 0%, rgba(10, 18, 36, 0.9) 100%)",
                border: "1px solid rgba(0, 255, 151, 0.3)",
              }}
            >
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#00FF97",
                  fontSize: "14px",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: "0.8px",
                  marginBottom: "16px",
                }}
              >
                <i className="fas fa-microchip"></i>
                {t.projectDetails.solutionTitle}
              </div>
              <p
                style={{
                  fontSize: "1.02rem",
                  lineHeight: "1.8",
                  color: "rgba(255,255,255,0.9)",
                  margin: 0,
                }}
              >
                {project.solution || project.description}
              </p>
            </div>
          </div>
        </div>

        {/* ========= DELIVERABLES / SCOPE OF SOLUTION ========= */}
        <div className="services-outcome-wrap mb-70">
          <h2 className="details-content-title mb-15" style={{ fontSize: "26px" }}>
            {t.projectDetails.solutionScopeTitle}
          </h2>
          <p style={{ color: "rgba(255,255,255,0.8)", fontSize: "16px" }}>
            {t.projectDetails.solutionScopeDesc}
          </p>

          <ul className="service-outcome-list project-requerment list-unstyled mt-35">
            {deliverablesList.map((text, index) => (
              <li key={index}>
                <span>
                  <CheckIcon />
                </span>
                {text}
              </li>
            ))}
          </ul>
        </div>

        {/* ========= QUANTIFIABLE ROI & IMPACT CARDS ========= */}
        <div className="mb-70">
          <h2 className="details-content-title mb-15" style={{ fontSize: "26px" }}>
            {t.projectDetails.roiTitle}
          </h2>
          <p style={{ color: "rgba(255,255,255,0.8)", fontSize: "16px" }}>
            {t.projectDetails.roiDesc}
          </p>

          <div className="row mt-35 g-4">
            {project.impact.map((imp, idx) => (
              <div className="col-lg-4 col-md-6" key={idx}>
                <div
                  style={{
                    padding: "28px 24px",
                    borderRadius: "16px",
                    backgroundColor: "rgba(10, 18, 36, 0.8)",
                    border: "1px solid rgba(0, 255, 151, 0.3)",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.4)",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      color: "#00FF97",
                      fontSize: "32px",
                      fontWeight: 800,
                      marginBottom: "10px",
                    }}
                  >
                    {idx === 0 ? "⚡ 15s" : idx === 1 ? "🎯 99.6%" : "💰 45%"}
                  </div>
                  <p
                    style={{
                      color: "rgba(255,255,255,0.9)",
                      margin: 0,
                      fontSize: "14.5px",
                      lineHeight: "1.6",
                    }}
                  >
                    {imp}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ========= TECHNOLOGIES USED ========= */}
        <div className="mb-70">
          <h3 className="details-content-title mb-20" style={{ fontSize: "22px" }}>
            {t.projectDetails.techStackTitle}
          </h3>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            {project.techs.map((tech, i) => (
              <span
                key={i}
                style={{
                  fontSize: "13px",
                  fontWeight: 600,
                  padding: "8px 18px",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.06)",
                  border: "1px solid rgba(255,255,255,0.12)",
                  color: "#00FF97",
                }}
              >
                {tech}
              </span>
            ))}
          </div>
        </div>

        {/* ========= CTA CONSULTATION ========= */}
        <div
          className="text-center mt-70 p-5"
          style={{
            borderRadius: "20px",
            background: "linear-gradient(135deg, rgba(0, 255, 151, 0.08) 0%, rgba(0, 2, 15, 0.8) 100%)",
            border: "1px solid rgba(0, 255, 151, 0.3)",
            backdropFilter: "blur(16px)",
          }}
        >
          <h3 style={{ color: "#fff", fontSize: "28px", fontWeight: 700, marginBottom: "12px" }}>
            {t.projectDetails.ctaTitle}
          </h3>
          <p
            style={{
              color: "rgba(255,255,255,0.8)",
              fontSize: "16px",
              maxWidth: "640px",
              margin: "0 auto 25px",
            }}
          >
            {t.projectDetails.ctaDesc}
          </p>
          <Link to="/contact" className="thm-btn agency-btn">
            <span className="text">{t.nav.consultation}</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProjectDetailsSection;
